import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  bookingDetailsAddOnsCalculationV2,
  bookingPriceCalculation,
} from "../../utils/bookingHelper";

const useBookingCalculation = (setCalculationResult, setRoomCountMap) => {
  const {
    selectedRoomWTypeAndNum,
    roomPriceStructure,
    nightsCount,
    detailedPriceBreakup,
    taxIncludedInPriceLocalState,
    invoiceDetails,
  } = useSelector((store) => store.booking);

  const { occupancyPlanRate, hotelDetails } = useSelector(
    (store) => store.login
  );
  const roomTypes = hotelDetails?.roomTypes ? hotelDetails?.roomTypes : [];
  const { taxResponse } = useSelector((store) => store.tax);

  useEffect(() => {
    if (!Array.isArray(roomPriceStructure) || roomPriceStructure?.length <= 0)
      return;

    let roomInvoice = invoiceDetails?.find(
      (Obj) => Obj?.invoiceType === "roomBill"
    );

    let discountInfo = Boolean(roomInvoice) ? roomInvoice?.discountInfo : {};
    let taxObjectArray = roomInvoice?.taxObjects;

    let alreadyPresentTaxArray = Array.isArray(roomInvoice?.taxObjects)
      ? roomInvoice?.taxObjects
      : [];
    const alreadyPresentTaxSet = new Set(
      Array.isArray(roomInvoice?.taxObjects)
        ? roomInvoice.taxObjects.map((obj) => obj.taxId)
        : []
    );

    const requiredTaxResponse = [
      ...alreadyPresentTaxArray,
      ...taxResponse?.filter((obj) => !alreadyPresentTaxSet.has(obj?.id)),
    ];

    const result = bookingPriceCalculation(
      detailedPriceBreakup,
      taxResponse
    );

    let localAddOnsArray = roomInvoice?.priceBreakup?.filter(
      (Obj) => Obj?.type === "Addons"
    );

    localAddOnsArray = Array.isArray(localAddOnsArray)
      ? localAddOnsArray?.[0]?.addOns
      : [];

    let addOnsCalcResult = bookingDetailsAddOnsCalculationV2(
      localAddOnsArray,
      taxObjectArray
    );

    let resultObj = {
      roomTotal: result?.roomTotal,
      subTotal: result?.subTotal,
      total: result?.total + addOnsCalcResult?.totalRate,
      addOnsTotal: addOnsCalcResult?.baseRate,
      localTax: result?.totalRoomTax + addOnsCalcResult?.taxRate,
      totalTax: result?.totalRoomTax + addOnsCalcResult?.taxRate,
      discount: result?.discount,
      discountInfo: discountInfo,
    };

    setRoomCountMap(result?.roomTypeCountMap);
    setCalculationResult(resultObj);
  }, [
    invoiceDetails,
    taxIncludedInPriceLocalState,
    detailedPriceBreakup,
    occupancyPlanRate,
  ]);
};

export default useBookingCalculation;
